'use client';

import { useContext } from 'react';
import FooterComponent from 'app/components/footer/footer';
import { UserContextV2 } from '@/app/services/providers/contexts/user-context';
import { useCTAsData } from '@/services/hooks/use-ctas-data';
export function PricingFooter() {
  const {
    user
  } = useContext(UserContextV2);
  const ctaData = useCTAsData('pricing-page-prefooter');
  const variant = !ctaData && Boolean(user) ? 'neutral' : 'red';
  return <FooterComponent variant={variant} className="pbs-96 md-pbs-128" utm_campaign="pricing" data-sentry-element="FooterComponent" data-sentry-component="PricingFooter" data-sentry-source-file="pricing-footer.tsx" />;
}